export const theme = {
    mode: 'dark',
    font: {
        head: 'Oswald, sans-serif',
        body: 'Roboto, sans-serif',
    },
    colors: {
        xdark: '#000000',
        dark: '#333333',
        light: '#ffffff',
        grey: '#cccccc',
        error: '#d0453e',
        primary: '#0984e3',
        primaryHover: '#2980b9',
        secondary: '#7f8c8d',
        secondaryHover: '#636e72',
        warning: '#f39c12',
        warningHover: '#e67e22',
        danger: '#d63031',
        dangerHover: '#c0392b',
        pink: '#e84393',
        purple: '#6c5ce7',
    },
    fontWeights: {
        light: 200,
        normal: 400,
        bold: 700,
    },
    fontSizes: {
        xs: '1rem',
        sm: '1.5rem',
        md: '2rem',
        lg: '2.5rem',
        xl: '3rem',
    },
    alignments: {
        left: 'left',
        right: 'right',
        center: 'center',
    },
    borderRadius: {
        radiusSmall: '.3rem',
        radiusMedium: '1rem',
        radiusLarge: '5rem',
    },
    windows: {
        fixed: 'min(90%, 1360px)',
        fluid: '100%',
    },
    sizes: {
        xs: '.3rem',
        sm: '.5rem',
        md: '1rem',
        lg: '1.5rem',
        xl: '2rem',
        xxl: '2.5rem',
    }
}